const PremiumFlag = () => (
  <span
    title="Premium members receive double coins for every dollar"
    className="mx-1 rounded-sm bg-yellow-400 px-2 text-sm font-bold tracking-wide text-black/60 uppercase"
  >
    100% Bonus
  </span>
);

export default PremiumFlag;
